// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","ccCountryNotice":"_1Huu"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddCreditCardForm/BillingAddCreditCardForm.scss
// module id = uYOi
// module chunks = 0